export const isEmpty = value => {
  if (Array.isArray(value)) {
    return value.length === 0;
  } else if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return !value;
};

// Organise classnames.
export const classList = classes => {
  return classes
    .reduce((acc, item) => {
      if (item) {
        acc += `${item} `;
      }

      return acc;
    }, '')
    .trim();
};

export const getNameInitials = name => {
  const nameArr = name?.split(' ');

  const fLetter = nameArr?.[0]?.[0] || '';
  const lLetter = nameArr?.[1]?.[0] || '';

  return `${fLetter} ${lLetter}`;
};

export const checkOnlineStatus = async () => {
  try {
    const online = await fetch(`${window.location.origin}/favicon.ico`);
    return online.status >= 200 && online.status < 300; // either true or false
  } catch (err) {
    return false; // definitely offline
  }
};

export const deepCopy = data => {
  if (!data) {
    return;
  }

  return JSON.parse(JSON.stringify(data));
};

export const convertFirstLetterToUpperCase = str => {
  return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
};

export const convertFirstLetterToLowerCase = str => {
  return `${str.charAt(0).toLowerCase()}${str.slice(1)}`;
};

export function camelize(str) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '');
}

export const isFilled = fieldValue => {
  if ([undefined, null, ''].includes(fieldValue)) {
    return '';
  } else {
    return 'p-filled';
  }
};

export function after(count, f) {
  let noOfCalls = 0;

  return function (...rest) {
    noOfCalls = noOfCalls + 1;
    if (count === noOfCalls) {
      f(...rest);
    }
  };
}

export function smallcaseWithUnderscore(str) {
  let strCopy = str;
  return strCopy ? strCopy?.toLowerCase()?.replaceAll(' ', '_') : '';
}

export const getSectionFromPath = (path) => {
  //path = "amenities.facilities.code_hac_7086.active"
  console.log(path.toString().split(".")[0]);
  
  return path.toString().split(".")[0];
}

export const getSubsectionFromPath = (path) => {
  return path.toString().split(".")[1];
}


